import * as types from "../actions/index";
export default function(state = { isLinkClick: false }, action) {
  switch (action.type) {
    case types.SET_GLOBALNAV_CLICK:
      return { ...state, ...action.payload };
    // no default
  }
  return state;
}
